const mainColors = {
  red: { base: 400, text: 800, light: 200 },
  pink: { base: 200, text: 900, light: 200 },
  orange: { base: 300, text: 900, light: 200 },
  yellow: { base: 300, text: 800, light: 200 },
  green: { base: 400, text: 800, light: 200 },
  blue: { base: 300, text: 800, light: 200 },
  purple: { base: 400, text: 800, light: 200 },
  brown: { base: 500, text: 800, light: 200 },
  gold: { base: 300, text: 800, light: 200 },
  dark: { base: 800, text: 800, light: 200 },
}

export default mainColors
